import React from 'react';
import SystemSettings from '../components/superadmin/SystemSettings';

const SuperadminSystemSettingsPage = ({ activeTab = 'system/general', onNavigate }) => {
  return <SystemSettings activeTab={activeTab} onNavigate={onNavigate} />;
};

export default SuperadminSystemSettingsPage;
